import React from 'react';
import MroLabLanePage from './MroLabLanePage';

export default function MroLabQmPage() {
  return <MroLabLanePage laneKey="qm" />;
}
